import http from "src/shared/http";
import projectOptions from "src/shared/project-options";
import makeURL from "src/shared/util/make-url";
import { BasketData } from "./model/BasketData";

export function fetchProductDetail(productUrl: string) {
  return http(productUrl);
}

export function addToBasket(basketData: BasketData) {
  const { basketUrl: _basketUrl, crsfToken } = projectOptions.default.network;

  const headers = {
    "Content-Type": "application/json",
    "X-CSRFToken": crsfToken,
  };

  const basketUrl = makeURL(_basketUrl).href;

  return http(basketUrl, { method: "POST", body: basketData, headers });
}
